import { createRouter, createWebHistory } from 'vue-router'
import Admin from '../views/Admin.vue'
import Confirmation from '../views/Confirmation.vue'
import Login from '../views/Login.vue'
import QuoteDetail from '../views/QuoteDetail.vue'
import QuoteRequest from '../views/QuoteRequest.vue'
import QuoteView from '../views/QuoteView.vue'
import Test from '../views/Test.vue'

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { title: 'Login - Solicitar Cotação Seguro' }
  },
  {
    path: '/admin',
    name: 'Admin',
    component: Admin,
    meta: { requiresAuth: true, title: 'Admin - Solicitar Cotação Seguro' }
  },
  {
    path: '/quote-detail/:id',
    name: 'QuoteDetail',
    component: QuoteDetail,
    meta: { requiresAuth: true, title: 'Detalhes da Cotação - Solicitar Cotação Seguro' }
  },
  {
    path: '/quote-request',
    name: 'QuoteRequest',
    component: QuoteRequest,
    meta: { title: 'Solicitar Cotação Seguro' }
  },
  {
    path: '/confirmation',
    name: 'Confirmation',
    component: Confirmation,
    meta: { title: 'Confirmação - Solicitar Cotação Seguro' }
  },
  {
    path: '/quote-view/:id',
    name: 'QuoteView',
    component: QuoteView,
    meta: { title: 'Visualizar Cotação - Solicitar Cotação Seguro' }
  },
  {
    path: '/test',
    name: 'Test',
    component: Test,
    meta: { title: 'Teste - Solicitar Cotação Seguro' }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// Guarda de rota para autenticação
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  
  // Definir título da página
  if (to.meta.title) {
    document.title = to.meta.title
  }
  
  if (to.meta.requiresAuth && !token) {
    next('/login')
  } else if (to.path === '/login' && token) {
    next('/admin')
  } else {
    next()
  }
})

export default router
